<template>
  <div class="woyaofankui">
    <div class="fk-title">{{$t('all.fankuiwenti')}}</div>
    <div class="fk-box">
      <textarea v-model="form.content" :placeholder="$t('all.qingmiaoshuniyaofankuidewenti')" placeholder-style="color:rgba(255,255,255,0.6)"></textarea>
      <div class="fk-box-img">
        <!-- 遍历图片列表进行预览 -->
        <div class="fk-box-img-item" v-for="(image, index) in imagesList" :key="image.id">
          <!-- 使用 v-if 和 v-else 来显示不同的上传状态 -->
          <img v-if="image.status === 'success'" class="fk-box-img-item-img1" :src="image.url" alt="反馈图片" />
          <div v-else-if="image.status === 'uploading'" class="uploading-indicator">
            <span>{{$t('all.shangchuanzhong')}}...</span>
          </div>
          <div v-else class="error-indicator">
            <span>{{$t('all.shangchuanshibai')}}</span>
          </div>
		  <img class="delImg" v-if="image.status === 'success'" @click="delImage(index)" src="../../assets/image/img_sc.png" alt="" />
        </div>

        <!-- 限制最多上传9张图片 -->
        <img
          v-if="imagesList.length < 9"
          class="fk-box-img-img"
          src="../../assets/image/tianjia_tupian@2x.png"
          alt="添加图片"
          @click="handleUploadClick"
        />

        <!-- 隐藏的文件选择器 -->
        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept="image/*"
          multiple
          @change="handleFileChange"
        />
      </div>
    </div>
    <div class="fk-btn">
      <!-- 提交按钮在有内容或图片时才可用 -->
      <div class="btn" @click="submitFeedbackForm">{{$t('all.tijiao')}}</div>
    </div>
  </div>
</template>

<script>
// 导入腾讯云 COS 客户端创建函数（替换阿里云 OSS）
import { client as createCosClient } from '../../common/js/txycos';
import { submitFeedback } from "@/api/user";

export default {
  name: 'woyaofankui',
  data() {
    return {
      form: {
        content: '',
        imgContent: ''
      },
      imagesList: [],
      cosClient: null, // 替换为腾讯云 COS 客户端实例
      // 腾讯云 COS 基础配置（可从 cosClient 中提取，也可直接配置）
      cosConfig: {
        bucket: 'unishow-live-1383640469',
        region: 'ap-hongkong'
      }
    };
  },
  computed: {
    canSubmit() {
      return this.form.content.trim() !== '' || this.imagesList.some(img => img.status === 'success');
    }
  },
  created() {
    // 初始化腾讯云 COS 客户端实例
    this.cosClient = createCosClient();
    if (!this.cosClient) {
      this.$message.error('腾讯云 COS 客户端初始化失败');
    }
  },
  methods: {
    handleUploadClick() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const fileList = event.target.files;
      if (!fileList.length) return;

      if (this.imagesList.length + fileList.length > 9) {
        this.$message.warning('最多只能上传9张图片');
        return;
      }

      Array.from(fileList).forEach(file => {
        const imageItem = {
          id: Date.now() + Math.random(),
          file,
          url: null,
          status: 'uploading'
        };
        this.imagesList.push(imageItem);
        this.uploadToCOS(imageItem); // 替换为腾讯云 COS 上传方法
      });
      
      event.target.value = '';
    },

    // 改造核心：腾讯云 COS 多图上传方法（替换阿里云 OSS 的 multipartUpload）
    async uploadToCOS(imageItem) {
      const { file, id } = imageItem;
      // 校验 COS 客户端是否有效
      if (!this.cosClient || typeof this.cosClient.putObject !== 'function') {
        this.$message.error('COS 客户端异常，无法上传图片');
        const index = this.imagesList.findIndex(item => item.id === id);
        if (index !== -1) {
          this.$set(this.imagesList, index, {
            ...this.imagesList[index],
            status: 'error'
          });
        }
        return;
      }

      try {
        // 1. 构造唯一文件名（保持与阿里云类似的路径结构，方便管理）
        const fileExt = file.name.split('.').pop() || 'png';
        const fileName = `webStorage/web_/${Date.now()}_${Math.random().toString(36).substr(2, 10)}.${fileExt}`;

        // 2. 调用腾讯云 COS putObject 方法上传（浏览器端多图上传核心）
        // 注：腾讯云 COS 浏览器端 SDK 无 multipartUpload，直接用 putObject 处理图片（适合小文件，图片通常满足）
        await new Promise((resolve, reject) => {
          this.cosClient.putObject({
            Bucket: this.cosClient.options.bucket, // 存储桶名称
            Region: this.cosClient.options.region, // 地域（无 cos. 前缀）
            Key: fileName, // 上传到 COS 的文件路径+名称
            Body: file, // 浏览器端文件对象
            ContentType: file.type || 'image/jpeg', // 兜底 MIME 类型
            onProgress: (progressData) => {
              // 可选：上传进度回调，如需显示进度可在此处理
              console.log(`文件 ${file.name} 上传进度：`, (progressData.percent * 100).toFixed(2) + '%');
            }
          }, (err, result) => {
            if (err) {
              reject(err);
            } else {
              resolve(result);
            }
          });
        });

        // 3. 拼接腾讯云 COS 图片访问 URL（两种方式均可）
        const imageUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${fileName}`;
        // 或使用 result.Location：const imageUrl = `https://${result.Location}`;

        // 4. 更新图片列表状态为上传成功
        const index = this.imagesList.findIndex(item => item.id === id);
        if (index !== -1) {
          this.$set(this.imagesList, index, {
            ...this.imagesList[index],
            url: imageUrl,
            status: 'success'
          });
        }
      } catch (error) {
        console.error(`文件 ${file.name} 上传失败:`, error);
        const index = this.imagesList.findIndex(item => item.id === id);
        if (index !== -1) {
          this.$set(this.imagesList, index, {
            ...this.imagesList[index],
            status: 'error'
          });
        }
        this.$message.error(`图片 ${file.name} 上传失败`);
      }
    },

    // 删除图片（原有逻辑不变，无需修改）
	delImage(index) {
		this.imagesList.splice(index, 1);
	},

    // 提交反馈（原有逻辑不变，无需修改）
    async submitFeedbackForm() {
	  const imageUrls = this.imagesList
	      .filter(img => img.status === 'success') 
	      .map(img => img.url)                    
	      .join(',');                          
	  this.form.imgContent = imageUrls;
	  const res = await submitFeedback(this.form);
	  this.$emit('closeFk');
	  this.$message.success(res.msg);
    }
  }
};
</script>

<style scoped lang="scss">
/* 引入你的CSS文件 */
@import "./woyaofankui.css";
</style>


// WEBPACK FOOTER //
// woyaofankui.vue?2479c96a